export const imageSliderClasses = {
  thumb: {
    active: 'slider-thumbnail-active',
  },
}
